
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 14C21 13.45 20.55 13 20 13H17.93C17.88 12.61 17.81 12.23 17.71 11.86L19.43 10.87C19.91 10.59 20.07 9.97998 19.8 9.49998C19.52 9.01998 18.91 8.85998 18.43 9.12998L16.92 9.99998C16.64 9.51998 16.3 9.08998 15.93 8.70998C15.97 8.47998 16 8.24998 16 7.99998C16 7.19998 15.76 6.44998 15.35 5.81998L16.29 4.87998C16.68 4.48998 16.68 3.85998 16.29 3.46998C15.9 3.07998 15.27 3.07998 14.88 3.46998L13.86 4.48998C12.18 3.59998 10.76 4.15998 10.13 4.48998L9.12 3.45998C8.73 3.06998 8.1 3.06998 7.71 3.45998C7.32 3.84998 7.32 4.47998 7.71 4.86998L8.65 5.80998C8.24 6.44998 8 7.19998 8 7.99998C8 8.24998 8.03 8.47998 8.07 8.71998C7.7 9.09998 7.36 9.52998 7.08 9.99998L5.57 9.12998C5.09 8.85998 4.48 9.01998 4.21 9.49998C3.93 9.97998 4.1 10.59 4.58 10.87L6.3 11.86C6.2 12.23 6.13 12.61 6.08 13H4C3.45 13 3 13.45 3 14C3 14.55 3.45 15 4 15H6.07C6.12 15.39 6.19 15.77 6.29 16.14L4.57 17.13C4.09 17.41 3.93 18.02 4.2 18.5C4.48 18.98 5.09 19.14 5.57 18.87L7.08 18C8.16 19.81 9.96 21 12 21C14.04 21 15.84 19.81 16.92 18L18.43 18.87C18.91 19.15 19.52 18.98 19.8 18.5C20.08 18.02 19.91 17.41 19.43 17.13L17.71 16.14C17.81 15.77 17.88 15.39 17.93 15H20C20.55 15 21 14.55 21 14ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-pest-control`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPestControl

    ```js
    <b-new-b-icon-pest-control />
    ```
</docs>


